/**
 * Created by dx.yang on 2017/2/6.
 */

import Vue from 'vue/dist/vue';

export default new Vue();
